<template>
  <section class="section section-drama">
    <div class="container">
      <div class="page-head">
        <h2>生成历史</h2>
        <p>查看和管理您的生成历史</p>
      </div>
      <div class="card">
        <div class="tab-buttons">
          <button 
            class="tab-btn" 
            :class="{active: activeTab == 'image'}"
            @click="activeTab = 'image'"
          >
            图片历史
          </button>
          <button 
            class="tab-btn" 
            :class="{active: activeTab == 'video'}"
            @click="activeTab = 'video'"
          >
            视频历史
          </button>
        </div>
        <div class="header-container">
          <button class="btn second" @click="refreshHistory" :disabled="loading">
            <span v-if="loading">刷新中...</span>
            <span v-else>刷新记录</span>
          </button>
        </div>
        
        <!-- 图片历史 -->
        <div v-if="activeTab == 'image'" class="history-list">
          <div v-if="imageHistory.length === 0" class="empty-state">
            <p>暂无图片生成记录</p>
          </div>
          <div v-else class="history-items">
            <div class="history-item" v-for="item in imageHistory" :key="item.id">
              <div class="history-item-content">
                <div class="history-item-header">
                  <h4>{{ item.prompt }}</h4>
                  <span class="history-item-date">{{ item.created_at }}</span>
                </div>
                <div class="history-item-details">
                  <span class="history-item-model">{{ item.model }}</span>
                  <span class="history-item-size">{{ item.size }}</span>
                </div>
                <button class="btn small" @click="viewImage">查看</button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 视频历史 -->
        <div v-if="activeTab == 'video'" class="history-list">
          <div v-if="videoHistory.length === 0" class="empty-state">
            <p>暂无视频生成记录</p>
          </div>
          <div v-else class="history-items">
            <div class="history-item" v-for="item in videoHistory" :key="item.id">
              <div class="history-item-content">
                <div class="history-item-header">
                  <h4>{{ item.prompt }}</h4>
                  <span class="history-item-date">{{ item.created_at }}</span>
                </div>
                <div class="history-item-details">
                  <span class="history-item-model">{{ item.model }}</span>
                  <span class="history-item-duration">{{ item.duration }}秒</span>
                </div>
                <button class="btn small" @click="viewVideo">查看</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'History',
  data() {
    return {
      activeTab: 'image',
      imageHistory: [],
      videoHistory: [],
      loading: false,
      user_id: 0
    }
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    this.user_id = userInfo.id || 0
    this.loadHistory()
  },
  methods: {
    async loadHistory() {
      this.loading = true
      try {
        const imageResponse = await axios.get('/api/image-history', {
          params: { user_id: this.user_id }
        })
        this.imageHistory = imageResponse.data

        const videoResponse = await axios.get('/api/video-history', {
          params: { user_id: this.user_id }
        })
        this.videoHistory = videoResponse.data
      } catch (error) {
        alert('加载历史记录失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    viewImage() {
      // 查看图片的逻辑
      alert('查看图片功能待实现')
    },
    viewVideo() {
      // 查看视频的逻辑
      alert('查看视频功能待实现')
    },
    refreshHistory() {
      this.loadHistory()
      alert('历史记录已刷新')
    }
  }
}
</script>

<style scoped>
.section-drama {
  padding-top: 100px;
}

.page-head {
  text-align: center;
  margin-bottom: 40px;
}

.page-head h2 {
  font-size: 32px;
  margin-bottom: 10px;
}

.page-head p {
  color: #888;
  font-size: 16px;
}

.card {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 16px;
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
}

.tab-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  padding-bottom: 10px;
}

.tab-btn {
  padding: 10px 20px;
  background: transparent;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 8px;
  color: #ccc;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-btn:hover {
  border-color: #00e6ac;
  color: #00e6ac;
}

.tab-btn.active {
  background: #00e6ac;
  color: #000;
  border-color: #00e6ac;
}

.header-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.btn.small {
  padding: 8px 16px;
  font-size: 14px;
}

.history-list {
  margin-top: 20px;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  color: #888;
}

.history-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.history-item {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.2s;
}

.history-item:hover {
  border-color: rgba(0,230,172,0.2);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.history-item-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.history-item-header h4 {
  font-size: 16px;
  margin: 0;
  flex: 1;
  text-align: left;
}

.history-item-date {
  font-size: 14px;
  color: #888;
  white-space: nowrap;
}

.history-item-details {
  display: flex;
  gap: 20px;
  font-size: 14px;
  color: #aaa;
  text-align: left;
}

@media (max-width: 768px) {
  .card {
    padding: 20px;
  }
  .history-item-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  .history-item-details {
    flex-direction: column;
    gap: 5px;
  }
}
</style>